<template>
    <div class="scoreboard" v-if="matchSummary !== null">
        <table>
            <thead>
                <tr>
                    <td>Teams</td>
                    <td><span class="icon-goal"></span></td>
                    <td><span class="icon-corner"></span></td>
                    <td><span class="icon-penalty"></span></td>
                    <td><span class="icon-yellow"></span></td>
                    <td><span class="icon-red"></span></td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{homeName}}</td>
                    <td>{{homeTeam.goals}}</td>
                    <td>{{homeTeam.corners}}</td>
                    <td>{{homeTeam.penalties}}</td>
                    <td>{{homeTeam.yellowCards}}</td>
                    <td>{{homeTeam.redCards}}</td>
                </tr>
                <tr>
                    <td>{{awayName}}</td>
                    <td>{{awayTeam.goals}}</td>
                    <td>{{awayTeam.corners}}</td>
                    <td>{{awayTeam.penalties}}</td>
                    <td>{{awayTeam.yellowCards}}</td>
                    <td>{{awayTeam.redCards}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import { HubConnection } from '@aspnet/signalr';
    export default {
        name: 'Soccer',
        data() {
            return {
                cornerTip: 'Corners',
                yellowCardTip: 'Yellow Cards',
                redCardTip: 'Red Cards',
                penaltyTip: 'Penalties',
                goalTip: 'Goals',

                matchSummary: null,

                homeName: null,
                homeTeam: {
                    goals: null,
                    yellowCards: null,
                    redCards: null,
                    corners: null,
                    penalties: null
                },

                awayName: null,
                awayTeam: {
                    goals: null,
                    yellowCards: null,
                    redCards: null,
                    corners: null,
                    penalties: null
                }
            }
        },
        props: {
            eventId: String,
            connection: HubConnection,
        },
        methods: {
            scoreboardUpdate(updatedScoreboard) {
                if (updatedScoreboard !== null && updatedScoreboard.Sport === "Football") {
                    var eventName = updatedScoreboard.EventName.split(" v ");
                    this.homeName = eventName[0];
                    this.awayName = eventName[1];

                    this.homeTeam.goals = updatedScoreboard && updatedScoreboard.GameState[0].Home.Goals;
                    this.homeTeam.yellowCards = updatedScoreboard && updatedScoreboard.GameState[0].Home.YellowCards;
                    this.homeTeam.redCards = updatedScoreboard && updatedScoreboard.GameState[0].Home.RedCards;
                    this.homeTeam.corners = updatedScoreboard && updatedScoreboard.GameState[0].Home.Corners;
                    this.homeTeam.penalties = updatedScoreboard && updatedScoreboard.GameState[0].Home.Penalties;

                    this.awayTeam.goals = updatedScoreboard && updatedScoreboard.GameState[0].Away.Goals;
                    this.awayTeam.yellowCards = updatedScoreboard && updatedScoreboard.GameState[0].Away.YellowCards;
                    this.awayTeam.redCards = updatedScoreboard && updatedScoreboard.GameState[0].Away.RedCards;
                    this.awayTeam.corners = updatedScoreboard && updatedScoreboard.GameState[0].Away.Corners;
                    this.awayTeam.penalties = updatedScoreboard && updatedScoreboard.GameState[0].Away.Penalties;

                    this.matchSummary = updatedScoreboard && updatedScoreboard.GameState[0].MatchSummary;
                }
            },
        },
        mounted() {
            if (this.connection) {
                this.connection.on(this.eventId + "_fixtureUpdate", (value) => {
                    this.scoreboardUpdate(JSON.parse(value));
                });
            }
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .scoreboard {
        margin: 0 auto;
        border: 2px solid white;
        width: 100%;
        margin-bottom: 15px;
        line-height: 25px;
    }

    .scoreboard table {
        width: 100%;
        border-spacing: 0;
    }

    .scoreboard table thead {
        background: #020381;
        width: 100%;
        color: gold;
        font-weight: 600;
    }

    .scoreboard table thead td {
        padding: 10px;
        text-align: center;
    }

    .scoreboard table thead td:first-child {
        text-align: left;
        width: 50%;
    }

    .scoreboard table tbody {
        background: #2b2b2b;
        width: 100%;
    }

    .scoreboard table tbody td {
        padding: 5px 10px;
        text-align: center;
    }

    .scoreboard table tbody td:first-child {
        text-align: left;
        color: white;
    }

    .icon-corner {
        background: url('../../assets/img/icons/sprites.png') 0 1px;
        display: inline-block;
        height: 14px;
        width: 16px;
    }

    .icon-yellow {
        background: url('../../assets/img/icons/sprites.png') 0 -29px;
        display: inline-block;
        height: 14px;
        width: 16px;
    }

    .icon-red {
        background: url('../../assets/img/icons/sprites.png') 0 -59px;
        display: inline-block;
        height: 14px;
        width: 16px;
    }

    .icon-penalty {
        background: url('../../assets/img/icons/sprites.png') 0 -208px;
        display: inline-block;
        height: 14px;
        width: 16px;
    }

    .icon-goal {
        background: url('../../assets/img/icons/sprites.png') 0 -237px;
        display: inline-block;
        height: 14px;
        width: 16px;
    }

    @media (max-width:426px) {
        .scoreboard table tbody td {
            font-size: 11px;
            padding: 5px 1px;
        }

        .scoreboard table thead td {
            padding: 4px;
        }
    }
</style>
